import React from "react";
import { Phone, Clock, Shield } from "lucide-react";
import { useSiteConfig } from "../lib/siteConfig";
import { callPhone } from "../lib/whatsapp";

/**
 * Slim top-of-page strip with the 24×7 support badge and one-tap contact CTAs.
 * Compact on mobile (icons only), verbose on desktop.
 */
export default function EmergencyBar({ informationOnly = false }) {
    const config = useSiteConfig();

    return (
        <div
            data-testid="emergency-bar"
            className="fixed inset-x-0 top-0 z-50 w-full bg-brand-navy text-white/90"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-1.5 text-xs sm:text-sm">
                <div className="flex items-center gap-2 sm:gap-4">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-emerald-300 sm:text-xs">
                        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
                        {informationOnly ? "Tourist Directory" : "24×7 Available"}
                    </span>
                    <span className="hidden items-center gap-1.5 text-white/70 md:inline-flex">
                        <Shield className="h-3.5 w-3.5" />
                        GST Registered · Verified Company
                    </span>
                    <span className="hidden items-center gap-1.5 text-white/70 lg:inline-flex">
                        <Clock className="h-3.5 w-3.5" />
                        {informationOnly ? "Tourist Information Only" : "Bookings taken any hour"}
                    </span>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-3">
                    <button
                        type="button"
                        data-testid="emergency-call"
                        onClick={() => callPhone(config.phone, "emergency-bar")}
                        className="inline-flex items-center gap-1.5 rounded-full bg-brand-gold/90 px-2.5 py-1 text-[11px] font-bold text-brand-navy transition hover:bg-brand-gold sm:px-3 sm:text-xs"
                        aria-label="Call VVPSS 24x7"
                    >
                        <Phone className="h-3.5 w-3.5" />
                        <span className="hidden sm:inline">{config.phone_display || "+91 94257 12055"}</span>
                        <span className="sm:hidden">Call</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
